import React from "react";
import { Stack } from "@mui/material";
import { RichTextDisplayListItem } from "./RichTextDisplayListItem";
import EditableRichText from "./UIParts/EditableRichText";
import { ContentItem } from "../interfaces/DTO/crm/contactComment";

interface Props {
  items: ContentItem[];
  enableNewItem?: boolean;
  newValue?: string;

  onNewSave?: (newValue: string) => void;
  isNewSaving?: boolean;
  onDelete?: (itemId: number) => void;
  onEdit?: (itemId: number, newValue: string) => void;
}

export const RichTextDisplayList: React.FC<Props> = ({
  items,
  enableNewItem = false,
  newValue = "",
 
  onNewSave,
  isNewSaving = false,
  onDelete,
  onEdit,
}) => {
  return (
    <Stack spacing={2} sx={{ width: "100%" }}>
      {/* יצירת פריט חדש בראש הרשימה */}
      {enableNewItem && onNewSave && (
        <EditableRichText
          value={newValue}
          onSave={onNewSave}
          isLoading={isNewSaving}
          enableEditing={true}
        />
      )}

      {/* הצגת רשימת פריטים קיימים */}
      {items.map((item) => (
        <RichTextDisplayListItem
          key={item.id}
          item={item}
          onDelete={onDelete}
          onEdit={onEdit}
        />
      ))}
    </Stack>
  );
};
